export default __webpack_public_path__ + "images/mg-f9101073ea57c9f7664cd8f4cc26effa.svg";